export default function TS_Introduction() {
  return (
    <div>
      <h1>TS Introduction</h1>
      <p>This is the TS Introduction page.</p>
    </div>
  );
}